import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch, useSelector } from "react-redux";
import * as url from "../../api/uri_helper"
import Loader from "../loader";
import axios from 'axios';
import Table, { Icon, Button } from "antd/lib/table";
import { useHistory } from "react-router-dom";
import Layout from '../Layout';
import updateIcon from "../../assets/images/updateIcon.svg"
import "antd/dist/antd.css";
import '../../../src/custom.css'
import { Select, Modal } from 'antd';
import { fetchSiteDetails } from '../../Redux/Api/fetch.api';
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { updateInstLocationData } from '../../Redux/Actions/LocationActions';
import { Tooltip } from 'antd';
import LinkIcon from '@mui/icons-material/Link';
import { fetchAllQrCodesWithThumbnail, LinkQRData } from "../../Redux/Api/fetch.api";
import { getQrCodeThumbnail } from '../../Redux/Actions/QR';
import LoginImage from "../../assets/images/login-image.png";
import { useTranslation } from "react-i18next";


const TOAST_LIMIT = 1;

const PrimarySecondaryIndex = () => {
    const { t } = useTranslation("dashboard");
    const { toasts } = useToasterStore();
    useEffect(() => {
        toasts
            .filter((t) => t.visible) // Only consider visible toasts
            .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit
            .forEach((t) => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) removal without animation
    }, [toasts]);
    const [selectedQR, setSelectedQR] = useState(null);
    const [loading, setLoading] = useState(false);
    const [table, setTable] = useState([]);
    const [tableChild, setTableChild] = useState();
    const [total, setTotal] = useState()
    const [pageSize, setPageSize] = useState(50);
    const [qRcodeId, setQRCodeId] = useState("");
    const [primaryqr, setPrimaryQR] = useState("");
    const [copyQRCodeId, setCopyQRCodeId] = useState();
    const [qRcodeError, setQRCodeError] = useState(false);
    const [showqrdropdown, setShowQRDropdown] = useState(false);
    const [count, setCount] = useState(0);
    const [checkedListOfIds, setCheckedListOfIds] = useState([]);
    const [options, setOptions] = useState({
        pagination: { current: 1 },
        pageSize: 50
    });
    const [searchState, setSearchState] = useState()

    const [pageData, setPageData] = useState({});
    const [siteData, setSiteData] = useState([]);
    const [bulkLocationId, setBulkLocationId] = useState()
    const dispatch = useDispatch();
    const [filteredSiteOptions, setFilteredSiteOptions] = useState([]);

    useEffect(() => {
        getParentChildData(options, true);
        getAllSites();
        getAllQRWithThumbnail();
    }, [])

    const getAllQRWithThumbnail = () => {

        fetchAllQrCodesWithThumbnail()
            .then(response => {
                dispatch(getQrCodeThumbnail(response.data));

            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const allQrDataWithThumbnail = useSelector((state) => state.allQrDataWithThumbnail.qrCodeThumbnailData);

    const getParentChildData = async (options, isReset = false) => {

        setLoading(true)
        const response = await axios.post(url.GET_PRIMARYSECONDARYLOCATIONDETAIL, {
            QRcodeId: isReset ? 0 : (qRcodeId > 0 ? qRcodeId : 0),
            PageIndex: isReset ? 1 : (options.pagination ? options.pagination.current : '1'),
            PageSize: isReset ? 50 : (options.pagination.pageSize !== undefined ? options.pagination.pageSize : options.pageSize),

        }).then(response => {

            setTable(response.data.data)
            setTableChild(response.data.data)
            setTotal(response.data.data.length > 0 ? response.data.data[0].totalCount : 0);
            setOptions({
                ...options,
                pagination: {
                    current: options.pagination ? options.pagination.current : 1,
                    pageSize: options.pagination.pageSize || pageSize,
                    total: response.data.data.length > 0 ? response.data.data[0].totalCount : 0,
                    pageSizeOptions: ['50', '100'],
                    showSizeChanger: true,
                }
            });


            setLoading(false)
        })
            .catch((err) => {
                console.log("Err: ", err);
            });
    };

    const getAllSites = () => {
        setLoading(true)
        fetchSiteDetails()
            .then(response => {
                if (response.data.success) {
                    setSiteData(response.data.data)
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const uncheckcheckbox = () => {
        var items = document.getElementsByName('checkname');
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == 'checkbox')
                items[i].checked = false;
        }
    }

    const { confirm } = Modal;
    const handleLink = (primaryqr) => {
        confirm({
            title: t("LinkQRConfirm"),
            okText: t("Yes"),
            okType: 'danger',
            cancelText: t("No"),
            onOk() {
                setSelectedQR(primaryqr);
                setShowQRDropdown(true);
                setPrimaryQR(primaryqr);
                setCheckedListOfIds([])
                uncheckcheckbox()
            },
            onCancel() {
            },
        });
    }

    const columns = [

        {
            title: t("PrimaryQR"),
            dataIndex: "primaryQR",
            key: "i"
        },

        {
            title: t("ProductName"),
            dataIndex: "product_Name",
            className: "Products",
            render: (product_Name) => <Tooltip title={product_Name}>{product_Name}</Tooltip>,

        },

        {
            title: t("SiteName"),
            dataIndex: "siteName",
        },

        {
            title: t("CompanyName"),
            dataIndex: "companyName",
        },

        {
            title: t("LinkQR"),
            key: 'index',
            className: "update_mapping",
            render: (text, record, index) => (
                <button
                    className={`assign-btn btn ${selectedQR === record.primaryQR ? "highlighted-icon" : ""}`}
                    id={index + 1}
                    onClick={() => {
                        handleLink(record.primaryQR);
                    }}
                >
                    <LinkIcon />
                </button>
            )
        }

    ]

    const handleCheck = (qRcodeId) => {
        var updatedList = [...checkedListOfIds];
        if (event.target.checked) {
            updatedList = [...checkedListOfIds, qRcodeId];
        } else {
            updatedList.splice(checkedListOfIds.indexOf(qRcodeId), 1);
        }
        setCheckedListOfIds([...updatedList]);
        setShowQRDropdown(false)
        setSelectedQR(null)

    };

    const handleInputForDropdown = (e) => {
        const QRProductPresent = allQrDataWithThumbnail.filter((item) => item.qRcodeId.toString().startsWith(e) || item.qRcodeId.toString().includes(e))
        QRProductPresent.length > 0 ? setSearchState("Number") : setSearchState("String")
    }


    const handleResetButton = async () => {
        setQRCodeError("")
        setQRCodeId("")
        getParentChildData(options, true)
        setShowQRDropdown(false)
        setSelectedQR(null)
        setCopyQRCodeId()
    }

    const handleBulkLocationUpdate = async () => {
        debugger;
        setLoading(true)
        if (checkedListOfIds.length >= 1) {
            const data = [];
            checkedListOfIds.map(x => data.push({
                QRcodeId: x,
                LocationId: bulkLocationId
            }))
            const response = await axios.put(url.UPDATE_INSTLOCATION,
                {
                    "InstLocationQrs": data
                }).then(response => {
                    debugger;
                    dispatch(updateInstLocationData(response.data))
                    setBulkLocationId();
                    if (!response.data.success) // False 
                    {
                        debugger;
                        toast.error(response.data.message, {
                            className: "toastSuccess",
                        });
                    }
                    else {
                        toast.success(response.data.message, {
                            className: "toastSuccess",
                        })
                    }
                    setLoading(false)
                })
            setQRCodeId()
            getParentChildData(options, false)
            setCheckedListOfIds('')
            uncheckcheckbox();

        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            getParentChildData(options, false)
        }
    }

    const getFullInstalDate = (date) => {
        // setLoading(true)
        if (date) {
            const dateAndTime = date.split('T');
            const time = dateAndTime[1].split(':')
            const newtime = time[0] + ':' + time[1]
            const times = time[0] > 12 ? time[0] % 12 : time[0]
            const newtime1 = times + ':' + time[1]
            if (time[0] && time[0] >= 12) {
                return dateAndTime[0].split('-').reverse().join('-') + ' , ' + newtime1 + " PM ";
            }
            else {
                return dateAndTime[0].split('-').reverse().join('-') + ' , ' + newtime + " AM ";
            }
        }
    };

    const expandedRowRender = (index) => {
        const nestedcolumns = [

            {
                title: " ",
                dataIndex: "qRcodeId",
                hidden: false,
                render: (qRcodeId) => (<div className="checkgroup">
                    {
                        <input type="checkbox" className="btn-checkbox" name="checkname"

                            onChange={() => { handleCheck(qRcodeId) }}
                            key={qRcodeId}
                        ></input>
                    }
                </div>)
            },

            {
                title: t("SecondaryQR"),
                dataIndex: "qRcodeId",
                key: "i"
            },

            {
                title: t("ProductName"),
                dataIndex: "product_Name",
                className: "Products",
                render: (product_Name) => <Tooltip title={product_Name}>{product_Name}</Tooltip>,

            },

            {
                title: t("CreatedDate"),
                className: "update_qrcode",
                dataIndex: "createdDate",
                //key: 'installation_Date',

                render: ((date) => getFullInstalDate(date))

            },

            {
                title: t("SiteName"),
                dataIndex: "siteName",
            },

            {
                title: t("CompanyName"),
                dataIndex: "companyName",
            },



        ]
        return <Table className="nested-table" columns={nestedcolumns} dataSource={
            tableChild[index].secondaryQRsList
        } pagination={false} />
    };

    const LinkQRCodes = () => {
        setLoading(true)
        const formData = new FormData();
        formData.append("PrimaryQR", primaryqr);
        formData.append("SecondaryQR", copyQRCodeId);
        LinkQRData(formData).then(response => {
            if (response.data.success) {
                toast.success(response.data.message, {
                    className: "toastSuccess",
                });
                getParentChildData(options, false);
                setCopyQRCodeId("");
                setShowQRDropdown(false)
                setSelectedQR(null)

            }
            else {
                toast.error(response.data.message, {
                    className: "toastSuccess",
                });
                setLoading(false);
            }
        })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const handleInputForSiteDropdown = (input) => {

        const filtered = siteData && siteData.filter(item => {
            const fullName = item.siteName;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredSiteOptions(filtered);
    };


    const handleChange = (pagination, sorter) => {
        const shouldResetPageIndex = pagination.pageSize !== options.pagination.pageSize;

        const updatedPagination = {
            ...pagination,
            current: shouldResetPageIndex ? 1 : pagination.current
        };

        const updatedOptions = {
            ...options,
            pagination: updatedPagination
        };

        setOptions(updatedOptions);
        setPageData(updatedOptions);

        getParentChildData(updatedOptions);
    };

    return (
        <Layout title="ParentChild QR Review">
            <Toaster />
            <>

                <div className="position-relative">

                    <div className="card-box-header d-flex w-100 flex-wrap align-items-center m-0 gap-3 justify-content-between">
                        <div className="flex-wrap  d-flex gap-2 filter-box1">
                            <span className="">{t("SearchByQR")}</span>
                            <div className="d-flex gap-3 width-box flex-wrap">
                                <div className="d-flex flex-column position-relative">
                                    <input type="text" className='form-control searchQR w-100 m-0' value={qRcodeId} placeholder={t("EnterQR")}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        onKeyPress={(e) => {
                                            if (new RegExp(/^[0-9\b]+$/).test(e.key)) {
                                            } else e.preventDefault();
                                        }}
                                        onKeyDown={(e) => handleKeyPress(e)}
                                        onChange={(e) => {
                                            const val = e.target.value.trim();
                                            const onlyNums = val.replace(/\D/g, '');

                                            setQRCodeId(onlyNums);
                                            setCount(onlyNums.length);

                                            if (onlyNums === "") {
                                                setQRCodeError("");
                                                getParentChildData(options, true)
                                            } else if (onlyNums.startsWith("0")) {
                                                setQRCodeError(t("EnterValidQR"))
                                            } else {
                                                setQRCodeError("");
                                            }
                                        }}
                                    >
                                    </input>
                                    {qRcodeError != "" ?
                                        <small className='text-danger d-block qRcodeError top-100 position-absolute position-md-absolute position-sm-relative' >{qRcodeError}</small> : ""
                                    }
                                </div>

                                <button className="searchButton"
                                    onClick={() => {
                                        if (qRcodeId.trim() === "") { setQRCodeError(t("PleaseEnterQRCode")) }
                                        else if (count < 2 && qRcodeId != "") { setQRCodeError(t("EnterValidQRCodeError")) }
                                       
                                      
                                        else { setQRCodeError("") }
                                        if (count > 2) {
                                            getParentChildData(options, false)
                                        }
                                    }}
                                  
                                // disabled={!qRcodeId}


                                >{t("Search")}</button>
                                {qRcodeId == "" ? "" : <button className='searchButton'
                                    onClick={() =>
                                        handleResetButton()}
                                >{t("Reset")}</button>}
                            </div>


                        </div>
                        {checkedListOfIds.length >= 1 && !showqrdropdown ?
                            <div className="update_location flex-wrap  d-flex gap-2 filter-box1" >
                                {checkedListOfIds.length >= 1 && !showqrdropdown ?
                                    <span className="locan">{t("UpdateSiteLabel")}</span> : ""
                                }
                                <div className="d-flex gap-2 width-box flex-wrap">
                                    {checkedListOfIds.length >= 1 ?
                                        <Select class="form-select mb-0 flex-grow-1 filter-select " aria-label=".form-select-lg example"
                                            showSearch
                                            style={{ width: "200px" }}
                                            className='custom-select-ss'
                                            placeholder={t("UpdateSite")}
                                            value={bulkLocationId}
                                            onSearch={(value) => {
                                                handleInputForSiteDropdown(value)
                                            }}
                                            filterOption={false}
                                            onChange={(e) => {
                                                setBulkLocationId(e)
                                            }}
                                        >
                                            {filteredSiteOptions.length > 0 ?
                                                filteredSiteOptions && filteredSiteOptions.map(item =>
                                                    <Option key={item.siteId} value={item.siteId}>
                                                        {item.siteName}
                                                    </Option>
                                                )
                                                :
                                                siteData && siteData.map(item =>
                                                    <Option key={item.siteId} value={item.siteId}>
                                                        {item.siteName}
                                                    </Option>
                                                )
                                            }

                                        </Select>
                                        : ""
                                    }

                                    {checkedListOfIds.length >= 1 && bulkLocationId ?
                                        <button className="searchButton" onClick={() => handleBulkLocationUpdate()}>{t("Update")}</button> :
                                        ""
                                    }
                                </div>



                            </div> : ""
                        }

                                
                        {showqrdropdown ?

                            <div class="d-flex gap-4 ml-auto align-items-center flex-wrap">

                                <div className="primary-qr-text">
                                    <b>{t("PrimaryQRLabel")}</b> {primaryqr}
                                </div>
                                <div className="filter-box-1 d-flex gap-2 align-items-center">
                                    <span>{t("SelectSecondaryQR")} </span>
                                    <div class="d-flex select-qr-select gap-2">
                                        <Select
                                            class="form-select mb-0 flex-grow-1 filter-select"
                                            aria-label=".form-select-lg example"
                                            showSearch
                                            value={copyQRCodeId}
                                            optionFilterProp="label" // search works on label
                                            optionLabelProp="label" // show label in selected box
                                            onChange={(e) => {
                                                setCopyQRCodeId(e); // Always QRcodeId
                                            }}
                                            onSearch={(e) => {
                                                handleInputForDropdown(e)
                                            }}
                                            dropdownAlign={{ points: ['tr', 'br'], offset: [0, 4] }}
                                            dropdownStyle={{ minWidth: 300 }}
                                        >
                                            <Option value="0">{t("SelectQR")}</Option>
                                            {allQrDataWithThumbnail &&
                                                allQrDataWithThumbnail
                                                    .filter(QRCode => QRCode.qRcodeId !== primaryqr)
                                                    .map((QRCode, k) =>

                                                        <Option
                                                            key={QRCode.qRcodeId}
                                                            value={QRCode.qRcodeId}
                                                            label={`${QRCode.qRcodeId}`}
                                                        >
                                                            <div className="d-flex gap20 align-items-center">
                                                                <div className="avatar-img">
                                                                    {QRCode.filename ?
                                                                        <>
                                                                            < img className="img-mapping" src={QRCode.filename}></img>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            < img className="img-mapping" src={LoginImage}></img>
                                                                        </>}
                                                                </div>
                                                                <div className="qrDesc content d-flex">
                                                                    {QRCode.product_Name ? <Tooltip title={QRCode.product_Name}>
                                                                        <h6>{QRCode.product_Name}</h6>
                                                                    </Tooltip>
                                                                        : <h6>{t("NA")}  </h6>}
                                                                    <p>{QRCode.qRcodeId}</p>
                                                                    <Tooltip title={QRCode.qR_Description}>
                                                                        <p>{QRCode.qR_Description}</p>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        </Option>

                                                    )}
                                        </Select>

                                        {showqrdropdown && copyQRCodeId ?
                                            <button className="searchButton"
                                                onClick={() => {
                                                    // setShowQRDropdown(false);
                                                    LinkQRCodes()

                                                }}
                                            >
                                                {t("Save")}  </button> :
                                            ""
                                        }
                                    </div>
                               </div>
                            </div>

                            : ""
                        }

                    </div>




                </div>


                <div className="table-responsive Viewer-table position-relative mb-4 device-type pagination-sticky data-table">
                    {loading ? <Loader /> : ''}
                    <Table
                        className='table-responsive antd--detail-table1 Viewer-table'
                        columns={columns}
                        dataSource={table}
                        expandedRowRender={(_, index) => expandedRowRender(index)}
                        pagination={
                            total > 50 ? options.pagination : false
                        }
                        onChange={handleChange}


                        scroll={{ x: "750px" }}
                    ></Table>
                </div>
            </>
        </Layout>
    )
}

export default connect()(PrimarySecondaryIndex);
